var map = {
	"./ErrorPage.svg": 9911,
	"./driver_icon.svg": 2221,
	"./favicon.ico": 4162,
	"./favicon.svg": 6927,
	"./footer_assets.svg": 3988,
	"./header_assets.svg": 1907,
	"./price_tag.svg": 3112,
	"./social_media.svg": 8230,
	"./ui_assets.svg": 6916
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3771;